import React from 'react';
import { Clock } from 'lucide-react';

interface DashboardHeaderProps {
    userName: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ userName }) => {
    return (
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold">Dashboard</h1>
                    <p className="mt-2 text-blue-100">
                        Hoş geldiniz, {userName}!
                    </p>
                </div>
                <div className="hidden sm:block">
                    <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-4 py-2">
                        <Clock className="h-5 w-5" />
                        <span className="text-sm">
                            {new Date().toLocaleDateString('tr-TR', {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardHeader;
